<template>
  <!-- 故障信息 -->
  <div class="card">
    <b-card-header class="border-0">
      <h5 class="card-title mb-0">{{this.$t('page.repair-request.FaultMessage')}}</h5>
    </b-card-header>
    <b-card-body class="border-0 border-top">
      <div>
        <label class="mb-3">{{this.$t('page.problem_description')}}</label>
        <div class="problem-describtion text-color">
          <editable-field
              :value="content"
              type="textarea"
              :editable="editable && hasPermissionFor('service.patch')"
              :h5-wrap="false"
              @complete="editField($event,'content')"
          ></editable-field>
        </div>
      </div>
      <div class="mt-5">
        <label class="mb-3">{{this.$t('page.attachment')}}</label>
        <div class="d-flex">
          <upload-with-preview
              :value="detail.attachment"
              input-id="uploadAttachment"
              :multiple="true"
              preview-type="thumb"
              filename-prefix="repair"
              :can-delete="editable && hasPermissionFor('service.patch')"
              :show-upload-btn="editable && hasPermissionFor('service.patch')"
              @changed="attachmentChange"
          ></upload-with-preview>
        </div>
      </div>
    </b-card-body>
  </div>
  <!-- 设备信息 -->
  <div class="card" id="equipment-table">
    <b-card-header class="border-0 border-bottom mb-3">
      <h5 class="card-title mb-0">{{this.$t('page.deviceInfo')}}</h5>
    </b-card-header>
    <!-- 表单区域 -->
    <b-card-body style="max-height: 540px; overflow: auto">
      <div class="table-responsive">
        <table class="table align-middle table-nowrap mb-0">
          <thead class="table-light text-muted">
            <tr>
              <th
                class="sort"
                :data-sort="head"
                v-for="(head, h_index) in detailData.tableHead"
                :key="h_index"
              >
                {{ head }}
              </th>
            </tr>
          </thead>
          <tbody class="list form-check-all">
            <tr v-for="body of paginate(devices)" :key="body.id">
              <td>{{ deviceField(body, 'product_type_txt') }}</td>
              <td>
                {{ deviceField(body, 'name') }}
              </td>
            <!--   泵头序列号           -->
              <td>
                <a
                  v-if="!body.product_type || body.product_type == 1"
                  href="javascript:;"
                  class="cursor-pointer"
                  @click="handlerJump(body.id)"
              >{{ deviceField(body, 'root_sn')}}</a>
                <div v-else>
                  <div v-for="(child, cindex) in body.root_sn_list" :key="cindex">{{ child }}</div>
                </div>
              </td>
              <!--      机组序列号        -->
              <td>
                <a
                  v-if="body.product_type == 2"
                  href="javascript:;"
                  class="cursor-pointer"
                  @click="handlerJump(body.id)"
                >
                  {{ deviceField(body, 'root_sn') }}
                </a>
                <span v-else>{{ deviceField(body, 'group_sn') }}</span>
              </td>
              <td>{{ deviceField(body, 'begin_at') }}</td>
              <td>
                <span
                  :class="['badge', 'badge-soft-success']"
                >
                  {{ deviceField(body, 'warranty') }}
                </span>
              </td>
              <td>{{ deviceField(body, 'contact') }}</td>
              <td>{{ deviceField(body, 'contact_number') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card-body>
    <Pagination
      v-if="tab_info_length"
      v-model:page="page"
      v-model:perPage="perPage"
      :pages="pages"
      :prePageOption="prePageOption"
      :tab_info_length="tab_info_length"
      class="me-5 my-3"
    ></Pagination>
  </div>

  <!-- 关联工单 -->
  <div class="card">
    <b-card-header class="border-0 border-bottom mb-3">
      <h5 class="card-title mb-0">{{this.$t('page.relatedWorkOrder')}}</h5>
    </b-card-header>
    <!-- 表单区域 -->
    <b-card-body style="max-height: 540px; overflow: auto">
      <div class="table-responsive">
        <table class="table align-middle table-nowrap mb-0">
          <thead class="table-light text-muted">
          <tr>
            <template
              v-for="(head, h_index) in WorkOrderTableHeader"
              :key="h_index"
            >
              <th
                  v-show="head.visible"
                  class="sort"
              >
                {{ head.label }}
              </th>
            </template>
          </tr>
          </thead>
          <tbody class="list form-check-all">
          <tr v-for="(item, index) in orders" :key="index">
            <!--                      <th scope="row">-->
            <!--                        <div class="form-check">-->
            <!--                          <input class="form-check-input" type="checkbox" name="chk_child" :checked="checkedIds.includes(item.id)" @change="checkChange(item.id)" />-->
            <!--                        </div>-->
            <!--                      </th>-->
            <template
                v-for="(titleItem, titleIdx) in WorkOrderTableHeader"
                :key="titleIdx"
            >
              <td v-show="titleItem.visible">
                <wo-status-etc
                    v-if="
                              [
                                'priority',
                                'status',
                                'warranty_status',
                              ].includes(titleItem.name)
                            "
                    :value="item[titleItem.name]"
                    :field-name="titleItem.name"
                    :wo-data="item"
                />
                <router-link
                    v-else-if="titleItem.name == 'number'"
                    :to="'/work-order-detail/' + item['id']"
                >{{ item[titleItem.name] }}</router-link
                >
                <span v-else-if="titleItem.name == 'type'">{{
                    WO_TYPE.find((v) => v.value == item.type).label ||
                    ""
                  }}</span>
                <span v-else-if="titleItem.name == 'created_at'">{{
                    formatDatetime(item[titleItem.name])
                  }}</span>
                <span v-else-if="titleItem.name == 'engineer'"
                >{{ item.main_engineer_txt }}
                            {{ item.assist_engineer_txt }}</span
                >
                <span v-else>{{ item[titleItem.name] }}</span>
              </td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>
    </b-card-body>
  </div>
</template>

<script>
import {patchRepairService, workOrderList} from "@/service/index.js";
import _ from "lodash";
import {
  SERVICE_STATUS_CLOSED,
  SERVICE_STATUS_PENDING,
  SERVICE_STATUS_PROCESSED,
  SERVICE_STATUS_TO_BE_CLASSIFIED,
  WO_TYPE,
} from "@/config/common";
import EditableField from "@/views/work-order/components/widgets/editable-field";
import UploadWithPreview from "@/views/widgets/upload-files/upload-with-preview";
import {detailData} from "@/views/repair-request/components/data";
import { getDeviceInfo} from "@/helpers/common-service";
import {WorkOrderTableHeader} from "@/views/work-order/components/data";
import WoStatusEtc from "@/views/work-order/components/widgets/wo-status-etc";
import { formatDatetime } from "@/helpers/common";

export default {
  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["initDetailInfo"],
  data() {
    return {
      WO_TYPE,
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 15, 30, 40, 50],
      pages: [],
      /* 分页end */
      detailData,
      devices: [],
      detail: {},
      editable: false,
      content: '',
      WorkOrderTableHeader,
      orders: [],
    };
  },
  watch: {
    detailInfo: {
      immediate: true,
      handler(val) {
        console.log('detailInfo-left变化:', val)
        if (val) {
          this.detail = _.cloneDeep(val);
          this.content = this.detail.content
          if (![SERVICE_STATUS_PROCESSED, SERVICE_STATUS_CLOSED].includes(parseInt(this.detail.status))) {
            this.editable = true
          } else {
            this.editable = false
          }
          // 通过泵头序列号获取设备信息
          if (val.device_root_sn) {
            getDeviceInfo(val.device_root_sn).then(res => {
              this.devices = [res]
            }).catch(() => {
              // 没查到设备信息，只显示泵头序列号
              this.devices = [{root_sn: val.device_root_sn}]
            })
          }
          // 获取关联工单
          workOrderList({page_size: 0, service_request: val.id})
            .then((woRes) => {
              this.orders = woRes.payload;
            })
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.setPages();
  },
  methods: {
    formatDatetime,
    handlerJump(id) {
      this.$router.push({
        name: "equipment-detail",
        query: {
          equip_id: id,
        },
      });
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.devices.length;
      let numberOfPages = Math.ceil(
        this.devices.length / this.perPage
      );
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    /* 筛选分页数据 */
    paginate(orders) {
      if (orders && orders.length) {
        let page = this.page;
        let perPage = this.perPage;
        let from = page * perPage - perPage;
        let to = page * perPage;
        return orders.slice(from, to);
      }
    },
    // 附件修改
    attachmentChange(ids) {
      const form = {
        id: this.detailInfo.id,
        attachment: ids
      }
      this.edit(form)
    },
    editField(e,fieldName) {
      console.log(fieldName, `${this.$t('page.repair-request.TheFieldUpdatedTo')}：`, e)
      const form = {
        id: this.detailInfo.id,
      }
      form[fieldName] = e
      if (fieldName === 'type' && e && this.detailInfo.status == SERVICE_STATUS_TO_BE_CLASSIFIED) {
        form['status'] = SERVICE_STATUS_PENDING
      }
      this.edit(form)
    },
    edit(params) {
      patchRepairService(params.id, params).then((res) => {
        if (res && res.payload) {
          this.$emit("initDetailInfo");
        }
      });
    },
    deviceField(item, name) {
      return _.get(item, name, '')
    }
  },
  components: {
    EditableField,
    UploadWithPreview,
    WoStatusEtc,
  },
};
</script>

<style scoped lang="scss">
.card-body {
  font-size: 14px;
}
.problem-describtion {
  max-height: 60px;
  overflow: auto;
}

.img-list {
  width: 80px;
  height: 80px;
}

.text-color {
  color: #9599ad;
}
</style>
